import React from 'react';
import { useTranslation } from 'react-i18next';
import { Activity, RefreshCw, Clock } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Progress } from '../ui/progress';

const MonitoringStatusBar = ({
  realtimeEnabled,
  wsConnected,
  realtimeCount,
  lastRealtimeActivity,
  autoRefresh,
  refreshInterval,
  setRefreshInterval,
  refreshProgress,
}) => {
  const { t, i18n } = useTranslation();

  return (
  <div className="flex items-center justify-center flex-wrap gap-4">
    {realtimeEnabled && (
      <div className={`flex items-center space-x-2 text-sm px-4 py-2 rounded-lg ${
        wsConnected ? 'bg-green-950/40 text-green-400' : 'bg-yellow-950/40 text-yellow-400'
      }`}>
        {wsConnected ? (
          <Activity className="h-4 w-4 animate-pulse text-green-600" />
        ) : (
          <RefreshCw className="h-4 w-4 animate-spin text-yellow-600" />
        )}
        <span>
          {wsConnected
            ? t('zktecoComp.realtimeActiveCount', { count: realtimeCount })
            : t('zktecoComp.realtimeConnecting')}
        </span>
        {lastRealtimeActivity && (
          <span className="text-xs opacity-75">
            {t('zktecoComp.lastActivity')}: {lastRealtimeActivity.toLocaleTimeString(i18n.language)}
          </span>
        )}
      </div>
    )}

    {autoRefresh && (
      <div className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground bg-muted px-4 py-2 rounded-lg">
        <Clock className="h-4 w-4 text-muted-foreground" />
        <span>{t('zktecoComp.autoRefreshSeconds', { n: refreshInterval })}</span>
        <Progress value={refreshProgress} className="w-24 h-2" />
        <Select value={refreshInterval.toString()} onValueChange={(v) => setRefreshInterval(parseInt(v))}>
          <SelectTrigger className="w-20 h-8"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="5">5s</SelectItem>
            <SelectItem value="10">10s</SelectItem>
            <SelectItem value="30">30s</SelectItem>
            <SelectItem value="60">1min</SelectItem>
          </SelectContent>
        </Select>
      </div>
    )}
  </div>
  );
};

export default MonitoringStatusBar;
